import React from 'react';
import DropdownContainer from '../containers/DropdownContainer';
import Textarea from './Textarea';
import TextField from './TextField';
import Heading from './Heading';
import Note from './Note';

const FormSection = ({label, fields, fieldOrder}) => {
  return (
    <li>
      <h3><span>{label}</span></h3>
      {fieldOrder.toArray().map(function(fieldName) {
        let field = fields.get(fieldName).toObject();
        switch(field.form_element) {
          case 'dropdown':
            return <DropdownContainer key={field.name} field={field} />;
          case 'text':
            return <TextField key={field.name} field={field} />;
          case 'textarea':
            return <Textarea key={field.name} field={field} />;
          case 'heading':
            return <Heading key={field.name} field={field} />;
          case 'note':
            return <Note key={field.name} field={field} />;
        }
      })}
    </li>
  );
};

export default FormSection;
